import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import moment from "moment";

interface TrainingTime {
  id: number;
  training_id: number;
  start_at: string;
  finish_at: string;
}

export default class extends Controller {
  connect() {
    console.log('initTrainingsAttendance');
    const credit = $('#toJs').data('credit') as number;
    const tt = $('#toJs').data('tt') as TrainingTime;
    console.log(credit);
    console.log(tt);
    $(".participated").on('click', function () {
      const input = this as HTMLInputElement;
      console.log(input.checked);
      $(this).parent().next().find('input.datetime_picker').parent()
        .datetimepicker().data("DateTimePicker").date(input.checked ? moment(tt.start_at) : null);
      $(this).parent().next().next().find('input.datetime_picker').parent()
        .datetimepicker().data("DateTimePicker").date(input.checked ? moment(tt.finish_at) : null);
      $(this).parent().next().next().next().find('input.integer').val(input.checked ? credit : '');
    });
    $('input.datetime_picker').parent().datetimepicker().on('dp.change', function (e) {
      updateCredits($(this).closest('tr'));
      //$('#activity_started_at').parent().datetimepicker().data("DateTimePicker").date(e.date);
    });

    function updateCredits(tr: JQuery) {
      const start_at = $(tr.find('input.datetime_picker')[0]).parent().datetimepicker().data("DateTimePicker").date();
      const finish_at = $(tr.find('input.datetime_picker')[1]).parent().datetimepicker().data("DateTimePicker").date();
      if (finish_at && start_at) {
        let rate = (finish_at - start_at) / (moment(tt.finish_at).valueOf() - moment(tt.start_at).valueOf());
        if (rate < 0.7)
          rate = 0;
        if (rate > 1.0)
          rate = 1.0;
        console.log(rate);
        tr.find('input.integer').val(Math.ceil(rate * credit));
      }
    }

  }
}